/** Shared UI color tokens (landing + trust pages). */
export const colors = {
  green: '#34d399',
  greenDim: '#10b981',
  yellow: '#fbbf24',
  yellowDim: '#f59e0b',
  red: '#f87171',
  redDim: '#ef4444',
  blue: '#60a5fa',
  blueDim: '#3b82f6',
  bgPrimary: '#0a0f1a',
  bgSecondary: '#0f1623',
  bgTertiary: '#161f30',
  bgRaised: '#1d293d',
  textPrimary: '#f5f8fc',
  textSecondary: '#aab6cc',
  textMuted: '#6b7894',
  textFaint: '#4a5670',
  border: '#243049',
  borderLight: '#33415c',
  borderDark: '#1a2336',
  ctaInk: '#06281b',
} as const;
